import { TItemType } from '@modules/items';

const getItemPathByItemType = (itemType: TItemType) => {
  if (itemType === 'REPLICA_DOCUMENT') return 'synced';
  if (itemType === 'REPLICA_FILE') return 'synced';
  if (itemType === 'FOLDER') return 'folder';
  if (itemType === 'DOCUMENT') return 'document';
  if (itemType === 'FILE') return 'file';
  if (itemType === 'INLINE_BLOCK') return 'inline-block';
  return 'nopage';
};

export default getItemPathByItemType;
